import { captureException } from '@sentry/core'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { first } from 'lodash-es'

export const Route = createFileRoute('/dashboard/$regionId/messages/')({
  beforeLoad: ({ context }) => {
    const currentTeam = context.teams.find((team) => team.messagingStatus.hasUnreadTeamMessages) ?? first(context.teams)
    if (!currentTeam) {
      throw redirect({
        to: '/dashboard/$regionId/messages/none',
        from: Route.fullPath,
        replace: true,
      })
    }
    throw redirect({
      to: '/dashboard/$regionId/messages/$teamId',
      from: Route.fullPath,
      params: {
        teamId: currentTeam._id,
      },
      replace: true,
    })
  },
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
